import { CONTENT_SECTIONS } from '../../../content/sections';
import { Maybe, Question } from '../../../../../types/__codegen__/sanity/graphql';
import getFormattedQuestionForAccordion from '../../../../../utils/get-formatted-question-for-accordion';
import type { SectionQuestionType } from '../../../types';

const mapCommonQuestionsContent = ({
  cmsSectionContent,
}: {
  cmsSectionContent: Maybe<Maybe<Question>[]> | undefined;
}): SectionQuestionType | null => {
  if (!cmsSectionContent?.length) {
    return null;
  }

  return {
    isTwoColumn: false,
    items: getFormattedQuestionForAccordion(cmsSectionContent),
    type: CONTENT_SECTIONS.COMMON_QUESTIONS,
  };
};

export default mapCommonQuestionsContent;
